export default __webpack_public_path__ + "static/media/26.0a60bb71.png";